import plaintextrequest from "@/utils/plaintextrequest";
import request from "@/utils/request";

// 游戏详情
export function gamedetails(data) {
  return plaintextrequest({
    url: "/gameindex/gamedetails",
    method: "post",
    data,
  });
}

// 收藏游戏
export function collection(data) {
  return plaintextrequest({
    url: "/game/collection",
    method: "post",
    data,
  });
}

// 游戏小号列表
export function xhlists(data) {
  return request({
    url: "/user/xhlists",
    method: "post",
    data,
  });
}

// 游戏礼包列表
export function giftlists(data) {
  return request({
    url: "/gameindex/giftlists",
    method: "post",
    data,
  });
}

// 领取礼包
export function getCode_xh(data) {
  return request({
    url: "/gift/getCode_xh",
    method: "post",
    data,
  });
}

// 礼包详情
export function cardDetails_xh(data) {
  return request({
    url: "/gift/cardDetails_xh",
    method: "post",
    data,
  });
}

// 游戏活动
export function activelists(data) {
  // console.log('activit---------------',data)
  return plaintextrequest({
    url: "/gameindex/activelists",
    method: "post",
    data,
    // tokenflag:'false',
    // isEncipher:'false'
  });
}

// 活动详情
export function newsdetail(data) {
  return plaintextrequest({
    url: "/Information/newsdetail",
    method: "post",
    data,
  });
}

// 游戏预约
export function bookingcount(data) {
  return plaintextrequest({
    url: "/game/booking_count",
    method: "post",
    data,
  });
}
// 648
export function get648(data) {
  return request({
    url: "/coupon/lists648",
    method: "post",
    data,
  });
}

//领取648抵扣券
export function get648Coupon(data) {
  // console.log('领取抵扣券的数据----------',data)
  return request({
    url: "/coupon/getcoupon648",
    method: "post",
    data,
  });
}

// 领取新人福利优惠券
export function getNewUserCoupon(data) {
  return request({
    url: "/Coupon/getcouponwelfare",
    method: "post",
    data,
  });
}

// 安心玩信息
export function getsafeplay(data) {
  return request({
    url: "/gameindex/axwdetails",
    method: "post",
    data,
  });
}

// 安心玩回收
export function getsafeplayback(data) {
  //   console.log("data----------", data);
  return request({
    url: "/gameindex/dorecovery",
    method: "post",
    data,
  });
}

// 免费版游戏接口
export function getFreeGame(data) {
  return plaintextrequest({
    url: "/game/freelist",
    method: "post",
    data,
  });
}
// 免费版换一换
export function getFreeGameChange(data) {
  return plaintextrequest({
    url: "/game/lasthotgame",
    method: "post",
    data,
  });
}

// GM相关接口
export function getGmGame(data) {
  return request({
    url: "https://hzzksq.5535.cn/box/gameindex/getGmDetails",
    method: "post",
    data,
  });
}

// 买断
export function getMdGame(data) {
  return request({
    url: "/gameindex/getMdbDetails",
    method: "post",
    data,
  });
}

export function getLcDetails(data) {
  return request({
    url: "https://hzzksq.5535.cn/box/gameindex/getLcDetails",
    method: "post",
    data,
  });
}
// 获取道具信息
export function getGmgoodsApi(data) {
  return request({
    url: "https://hzzksq.5535.cn/box/gameindex/getItemsLists",
    method: "post",
    data,
  });
}
// 获取GM实付价格
export function getGmPrice(data) {
  return request({
    url: "https://hzzksq.5535.cn/box/gameindex/getActualPrice",
    method: "post",
    data,
  });
}
// 买断发放接口
export function mdGive(data) {
  // console.log("发放接口----------", data);
  return request({
    url: "/gameindex/mdbItemDistributionInterface",
    method: "post",
    data,
  });
}

export function gmGive(data) {
  // console.log("发放接口----------", data);
  return request({
    url: "https://hzzksq.5535.cn/box/gameindex/itemDistributionInterface",
    method: "post",
    data,
  });
}

export function gmGive2(data) {
  // console.log("发放接口----------", data);
  return request({
    url: "https://hzzksq.5535.cn/box/gameindex/lcitemff",
    method: "post",
    data,
  });
}

// GM支付
export function gmAlipay(data) {
  return request({
    url: "https://hzzksq.5535.cn/box/alipay/gmAlipay",
    method: "post",
    data,
  });
}
// 微信支付
export function gmWxpay(data) {
  return request({
    url: "https://hzzksq.5535.cn/box/wxpay/gmwxpay",
    method: "post",
    data,
  });
}


// 游戏签到信息
export function gameSignInfo(data) {
  return plaintextrequest({
    url: "/PublicH5/appSigninIndex",
    method: "post",
    data,
  });
}

// 签到礼包列表
export function gameCheckinList(data) {
  return plaintextrequest({
    url: "https://hzzksq.5535.cn/box/game/checkinlist",
    method: "post",
    data,
  });
}

// 游戏签到
export function gameSign(data) {
  return request({
    url: "/PublicH5/signinAndReceive",
    method: "post",
    data,
  });
}
